import Types from "./types";
import {  BffDataAU } from "../../../service";

const fetchCmsDataInit = () => ({
    type: Types.FETCH_CMS_CONTENT_INIT
});
const fetchCmsDataSuccess = (data) => ({
    type: Types.FETCH_CMS_CONTENT_SUCCESS,
    data
});
const fetchCmsDataFailure = (error) => ({
    type: Types.FETCH_CMS_CONTENT_FAILURE,
    error
});

const updateShowInspectionForm = (data) => ({
    type: Types.UPDATE_SHOW_INSPECTION_FORM,
    data
});

const updateInspectionFormLoader = (data) => ({
    type: Types.UPDATE_INSPECTION_FORM_LOADER,
    data
});

const fetchRwcCmsContent = (slug, city = "") => async (dispatch) => {
    dispatch(fetchCmsDataInit());
    try {
        const response = await BffDataAU.getCmsContent({ slug, city });
        dispatch(fetchCmsDataSuccess(response.data));
        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(fetchCmsDataFailure(error));
        return Promise.reject(error);
    }
};

const postRwcInspectionForm = (token, payload) => async () => {
    try {
        const response = await BffDataAU.postRoadworthyCertificateInspectionDetails({token}, payload);
        return Promise.resolve(response.data);
    } catch (error) {
        return Promise.reject(error);
    }
};

export { fetchRwcCmsContent, updateShowInspectionForm, postRwcInspectionForm, updateInspectionFormLoader };
